// Pure helper functions for UmlCanvasToolbar, extracted 2026-07-13 to keep the
// toolbar class itself under the ~150-line rule. No `this`/instance dependency.

/**
 * Resolves a selectedId (from umlSelectionEngine) to display info — could be
 * a shape, a connector, a waypoint (search all connectors' points), or an
 * anchor ("connectorId:variant", see UmlConnectorEndpoints.jsx selectId).
 * @param {string|null} selectedId
 * @param {Function} getShapeById
 * @param {object[]} connectors
 * @returns {{label:string, geo:string}|null}
 */
export function resolveSelectedInfo(selectedId, getShapeById, connectors) {
    if (!selectedId) return null;

    const shape = getShapeById(selectedId);
    if (shape) {
        return {
            label: shape.caption?.text || shape.name || '(no name)',
            geo: `x:${Math.round(shape.x)} y:${Math.round(shape.y)} w:${Math.round(shape.w)} h:${Math.round(shape.h)}`,
        };
    }

    const connector = connectors.find((c) => c.id === selectedId);
    if (connector) {
        const fromName = getShapeById(connector.fromShapeId)?.caption?.text || getShapeById(connector.fromShapeId)?.name;
        const toName = getShapeById(connector.toShapeId)?.caption?.text || getShapeById(connector.toShapeId)?.name;
        return { label: connector.kind, geo: `${fromName} → ${toName}` };
    }

    if (selectedId.includes(':')) {
        const [connectorId, variant] = selectedId.split(':');
        const anchorConnector = connectors.find((c) => c.id === connectorId);
        if (anchorConnector) {
            return { label: `Anchor (${variant})`, geo: `connector id:${connectorId.slice(0, 8)}` };
        }
    }

    for (const c of connectors) {
        const point = (c.points || []).find((p) => p.id === selectedId);
        if (point) {
            return { label: 'Waypoint', geo: `x:${Math.round(point.x)} y:${Math.round(point.y)}` };
        }
    }

    return null;
}
